import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Database } from './database'

@Injectable()
export class ConfigService {

    constructor(private http: HttpClient) { }

    getDbs(): Observable<Database[]> {
        console.log('get dbs');
        return this.http.get<any>('/api/dbs').pipe(
            map(dbs => {
                console.log(dbs);
                return dbs;
            }));
    }
}
